module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/call-bell-889b91a51e3ed2698063ece3af2976f2.svg";